import React, { useState } from 'react'
import { Link } from 'gatsby'
import './receitas-desktop.scss'
import bebidas from './images/Bebidas.svg'
import carnes from './images/CarnesAves.svg'
import guarnicoes from './images/Guarnicoes.svg'
import massas from './images/Massas.svg'
import paes from './images/PaesSalgados.svg'
// import peixes     from './images/Peixes.svg'
import sobremesas from './images/Sobremesas.svg'
import vegetais from './images/Vegetais.svg'
import Swiper from 'react-id-swiper'

const Molde = props => {
  return (
    <Link
      id='receitas'
      className={`pt-2 pb-4 ${props.to === props.active ? 'col nav-op-receitas-active' : 'col nav-op-receitas'}`}
      to={`/receitas/${props.to}/`}
      onClick={() => props.changeFilter(props.to)}
    >
      <img className="d-flex mx-auto icone-receitas" src={props.imagem} alt="imagem" />
      <span className="text-center font-Yanone font-size-1" style={{ color: '#1B7796', textTransform: 'none', lineHeight: '12px' }}>{props.categoria}</span>
    </Link>
  )
}

export default function ReceitasHeader ({ handleActive }) {
  const [active, setActive] = useState(handleActive)
  const setFiltro = (categoria) => {
    setActive(categoria)
  }
  const swiperParams = {
    slidesPerView: 4,
    spaceBetween: 5,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    }
  }
  return (
    <>
      <div className="d-md-block d-none">
        <nav id="nav-receitas" className="text-center mb-3 d-flex align-items-end">
          <div className="container">
            <div className="row">
              <div className="col-auto mr-5 text-left d-flex align-items-center">
                <h1 className="font-Yanone text-blue">Receitas DIA</h1>
              </div>
              <Molde
                categoria="Guarnições"
                imagem={guarnicoes}
                to="guarnicoes"
                changeFilter={setFiltro}
                active={active}
                id="ReceitasGuarnicoes"
              />
              <Molde
                categoria="Bebidas"
                imagem={bebidas}
                to="bebidas"
                changeFilter={setFiltro}
                active={active}
                id="ReceitasBebidas"
              />
              <Molde
                categoria="Carnes e Aves"
                imagem={carnes}
                to="carnes-e-aves"
                changeFilter={setFiltro}
                id="ReceitasCarnesAves"
                active={active}
              />
              <Molde
                categoria="Sobremesas"
                imagem={sobremesas}
                to="sobremesas"
                changeFilter={setFiltro}
                id="ReceitasSobremesas"
                active={active}
              />
              <Molde
                categoria="Vegetais"
                imagem={vegetais}
                to="vegetais"
                changeFilter={setFiltro}
                id="ReceitasVegetais"
                active={active}
              />
              <Molde
                categoria="Massas"
                imagem={massas}
                to="massas"
                changeFilter={setFiltro}
                id="ReceitasMassas"
                active={active}
              />
              <Molde
                categoria="Pães e Salgados"
                imagem={paes}
                to="paes-e-salgados"
                changeFilter={setFiltro}
                id="ReceitasPaesSalgados"
                active={active}
              />
            </div>
          </div>
        </nav>
      </div>
      <div className="d-md-none d-block" id='receita-swiper'>
        <nav id="nav-receitas" className="text-center mb-3">
          <div className="container">
            <div className="row justify-content-center" id="swiper-mobile-categorias">
              <div className="col-12">
                <h2 className="font-Yanone text-blue py-lg-0 py-2 mb-0 font-size-40px">Receitas DIA</h2>
              </div>
              <Swiper {...swiperParams} activeSlideKey= {active}>
                <div className={`d-flex ${active === 'guarnicoes' ? 'nav-op-receitas-active' : 'nav-op-receitas'}`} key='guarnicoes'>
                  <Molde
                    categoria="Guarnições"
                    imagem={guarnicoes}
                    to="guarnicoes"
                    changeFilter={setFiltro}
                    active={active}
                  />
                </div>
                <div className={`d-flex ${active === 'bebidas' ? 'nav-op-receitas-active' : 'nav-op-receitas'}`} key='bebidas'>
                  <Molde
                    categoria="Bebidas"
                    imagem={bebidas}
                    to="bebidas"
                    changeFilter={setFiltro}
                    active={active}
                  />
                </div>
                <div className={`d-flex ${active === 'carnes-e-aves' ? 'nav-op-receitas-active' : 'nav-op-receitas'}`} key='carnes-e-aves'>
                  <Molde
                    categoria="Carnes e Aves"
                    imagem={carnes}
                    to="carnes-e-aves"
                    changeFilter={setFiltro}
                    active={active}
                  />
                </div>
                <div className={`d-flex ${active === 'sobremesas' ? 'nav-op-receitas-active' : 'nav-op-receitas'}`} key='sobremesas'>
                  <Molde
                    categoria="Sobremesas"
                    imagem={sobremesas}
                    to="sobremesas"
                    changeFilter={setFiltro}
                    active={active}
                  />
                </div>
                <div className={`d-flex ${active === 'vegetais' ? 'nav-op-receitas-active' : 'nav-op-receitas'}`} key='vegetais'>
                  <Molde
                    categoria="Vegetais"
                    imagem={vegetais}
                    to="vegetais"
                    changeFilter={setFiltro}
                    active={active}
                  />
                </div>
                <div className={`d-flex ${active === 'massas' ? 'nav-op-receitas-active' : 'nav-op-receitas'}`} key='massas'>
                  <Molde
                    categoria="Massas"
                    imagem={massas}
                    to="massas"
                    changeFilter={setFiltro}
                    active={active}
                  />
                </div>
                <div className={`d-flex ${active === 'paes-e-salgados' ? 'nav-op-receitas-active' : 'nav-op-receitas'}`} key='paes-e-salgados'>
                  <Molde
                    categoria="Pães e Salgados"
                    imagem={paes}
                    to="paes-e-salgados"
                    changeFilter={setFiltro}
                    active={active}
                  />
                </div>
              </Swiper>
            </div>
          </div>
        </nav>
      </div>
    </>
  )
}
